/**
 * Accessibility helper — returns true when the user has requested reduced motion.
 * Every motion component early-returns if this is true.
 */
export const prefersReducedMotion = () =>
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;
